import { authHeader } from '../auth-header copy';
import { services } from '../services';

export const userService = {
    login,
    logout,
    register,
    changeRole,
    deleteLogin,
    getAll,
    changePassword
};


const emailValid = (email) => {
    const emailRegex = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
    return emailRegex.test(email);
}


function login(email, password) {

    let data = emailValid(email) ? {email, password} : {username: email, password};
    return services.restApi('login', 'POST', JSON.stringify(data));
    
}

function logout() {

    return services.restApi('logout', 'POST');
}

function register(object) {
    return services.restApi(`register`, 'POST', object);
}
function changePassword(object) {
    return services.restApi(`changepassword`, 'POST', object);
}
function changeRole(object) {
    return services.restApi(`changerole`, 'POST', object);
}

function deleteLogin(id) {
    return services.restApi(`deletelogin`, 'POST', {id});
}

// function register(user) {
//     const requestOptions = {
//         method: 'POST',
//         headers: authHeader(), //{ 'Content-Type': 'application/json' },
//         body: user //JSON.stringify(user)
//     };
//     return fetch(`register`, requestOptions).then(handleResponse);
// }

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`/users`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                localStorage.clear();
                location.reload(true);
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}
